export default __webpack_public_path__ + "static/media/signin.6aa69f93.svg";